module.exports = __webpack_public_path__ + "6fd4811f5d90b33f7fcbe1f6fc43957f.jpg";